var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',_vm._l((_vm.colors),function(color){return _c('tr',{key:color.color},[_c('td',[_c('div',{staticClass:"dot-div"},[_c('span',{staticClass:"dot",style:({background: color.color})})])]),_c('td',[_vm._v(" "+_vm._s(color.text)+" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }